const cache = new Map();

async function lazyCall(importer, fnName, args = [], options = {}) {
  const { memoize = false, ttl = 5 * 60 * 1000 } = options;
  const key = `${importer.toString()}::${fnName}::${JSON.stringify(args)}`;

  if (memoize) {
    const entry = cache.get(key);
    if (entry) {
      if (Date.now() - entry.ts < ttl) return entry.promise;
      cache.delete(key);
    }
  }

  const promise = importer().then((mod) => {
    const fn = mod[fnName];
    if (typeof fn !== "function")
      throw new Error(`Function ${fnName} not found in module`);
    return fn(...args);
  });

  if (memoize) {
    cache.set(key, { promise, ts: Date.now() });
    promise.catch(() => cache.delete(key));
  }

  return promise;
}

function clearLazyCache() {
  cache.clear();
}

export { clearLazyCache, lazyCall };
export default lazyCall;
